import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { LoginProviderSelectorComponent } from './security/components/login-provider-selector/login-provider-selector.component';

const sharedRoutes: Routes = [
  {
    path: '',
    component: LoginProviderSelectorComponent
  },
  {
    path: 'login',
    component: LoginProviderSelectorComponent
  },
  {
    path: 'login/idp/fail',
    loadComponent: async () =>
      import('./security/components/ext-login-fail/ext-login-fail.component').then((c) => c.ExtLoginFailComponent)
  },
  {
    path: 'login/idp/success',
    loadComponent: async () =>
      import('./security/components/ext-login-success/ext-login-success.component').then(
        (m) => m.ExtLoginSuccessComponent
      )
  },
  {
    path: 'success',
    loadComponent: async () =>
      import('./security/components/internal-login-success/internal-login-success.component').then(
        (m) => m.InternalLoginSuccessComponent
      )
  },
  {
    path: 'registration',
    loadComponent: async () =>
      import('./security/components/registration/registration.component').then((m) => m.RegistrationComponent)
  },
  {
    path: 'sync-confirmation',
    loadComponent: async () => import('./security/components/switch-sync-confirmation/switch-sync-confirmation.component').then((m) => m.SwitchSyncConfirmationComponent)
  },
  {
    path: 'email-linking',
    loadComponent: async () => import('./security/components/im-address-linking/im-address-linking.component').then((m) => m.ImAddressLinkingComponent)
  },
  {
    path: 'error/login',
    loadComponent: async () => import('./security/components/internal-login-error/internal-login-error.component').then((m) => m.InternalLoginErrorComponent)
  },
  {
    path: 'error/registration-session-expired',
    loadComponent: async () => import('./security/components/registration-session-expired/registration-session-expired.component').then((m) => m.RegistrationSessionExpiredComponent)
  },
  {
    path: 'logout',
    loadComponent: async () => import('./security/components/logout/logout.component').then((m) => m.LogoutComponent)
  },
  {
    path: 'logout-complete',
    loadComponent: async () => import('./security/components/logout-complete/logout-complete.component').then((m) => m.LogoutCompleteComponent)
  },
];

@NgModule({
  imports: [CommonModule, RouterModule.forRoot(sharedRoutes)],
  providers: [],
  exports: [RouterModule]
})
export class AppRoutingModule {}
